import React from 'react';
import SpotlightTour from './SpotlightTour';

// The Content Edits guided tour. Spotlights the real controls on the page —
// the "New edit request" button and the "Visual editor" button — and ends by
// launching the Visual Editor (which runs its own tour). The targets are the
// data-tour="..." hooks on those buttons in DashboardEdits.

export default function ContentEditsWalkthrough({ onClose, onLaunchVisual, visualAvailable }) {
  const steps = [
    {
      target: null,
      eyebrow: 'Welcome',
      title: 'Two ways to update your site',
      body: 'A quick walk-through of how to request a content change. You can replay it anytime via “How it works”.',
    },
    {
      target: '[data-tour="new-edit-request"]',
      placement: 'bottom',
      title: 'Describe a change',
      body: 'This opens a form: pick the page and priority, and for text or links give us the exact before → after. Best when you already know what you want.',
      finishLabel: visualAvailable ? undefined : 'Got it',
    },
  ];

  if (visualAvailable) {
    steps.push({
      target: '[data-tour="visual-editor"]',
      placement: 'bottom',
      eyebrow: 'The fun way',
      title: 'Or point at it',
      body: 'Open the Visual Editor to browse your real, live site and click exactly what you want changed. We snapshot it for the team automatically.',
      finishLabel: 'Open the Visual Editor',
    });
  }

  const onFinish = () => {
    onClose();
    if (visualAvailable) onLaunchVisual();
  };

  return <SpotlightTour steps={steps} onClose={onClose} onFinish={onFinish} />;
}
